/**
 * timedPromise resolves a promise with given value a set timeout
 * @param timeout - timeout in milliseconds
 * @param returnValue - Value to return
 */
export const timedPromise = <T extends unknown>(timeout: number, returnValue: T): Promise<T> =>
  new Promise((resolve): void => {
    setTimeout((): void => resolve(returnValue), timeout)
  })
